<div class="add-container">
    <h1 class="add-title">Configurare</h1>
    <form class="add-card__form" [formGroup]="form" (submit)="submitForm()">
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Durată interval blocare</mat-label>
                    <mat-select formControlName="durata_interval_blocare">
                        <mat-option *ngFor="let row of durataOptions" [value]="row.value">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['durata_interval_blocare'].valid && form.controls['durata_interval_blocare'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100" appearance="fill">
                    <mat-label>Durată programare</mat-label>
                    <mat-select formControlName="durata_programare">
                        <mat-option *ngFor="let row of durataOptions" [value]="row.value">
                            {{ row.name }}
                        </mat-option>
                    </mat-select>
                    <mat-error
                        *ngIf="!form.controls['durata_programare'].valid && form.controls['durata_programare'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label>Prima dată valabilă</mat-label>
                    <input matInput [matDatepicker]="minDatePicker" formControlName="min_date_available" readonly
                        (focus)="minDatePicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="minDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #minDatePicker></mat-datepicker>
                    <mat-error
                        *ngIf="!form.controls['min_date_available'].valid && form.controls['min_date_available'].touched">
                        Câmp obligatoriu
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col">
                <mat-form-field class="w-100">
                    <mat-label>Ultima dată valabilă</mat-label>
                    <input matInput [matDatepicker]="maxDatePicker" formControlName="max_date_available" readonly
                        (focus)="maxDatePicker.open()" />
                    <mat-hint>ZZ/LL/AAAA</mat-hint>
                    <mat-datepicker-toggle matIconSuffix [for]="maxDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #maxDatePicker></mat-datepicker>
                    <mat-error
                        *ngIf="!form.controls['max_date_available'].valid && form.controls['max_date_available'].touched && !form.controls['max_date_available'].hasError('invalidDateRange')">
                        Câmp obligatoriu
                    </mat-error>
                    <mat-error *ngIf="form.controls['max_date_available'].hasError('invalidDateRange')">
                        Selectați o perioadă validă
                    </mat-error>
                </mat-form-field>
            </div>
        </div>
        <div class="row">
            <div class="col d-flex justify-content-between">
                <button type="button" class="buttons" mat-flat-button (click)="closeDialog()">
                    {{ helper.dialogConfig.buttonLabels.close }}
                </button>
                <button class="buttons" mat-flat-button color="primary" type="submit" [disabled]="form.invalid">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </div>
        </div>
    </form>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>